import { useCurrentUser } from "@/context/UserContext";
import { Navigate, Outlet } from "react-router-dom";

interface RoleBasedRouteProps {
  allowedRoles: string[];
}

const RoleBasedRoute = ({ allowedRoles }: RoleBasedRouteProps) => {
  const { currentUser } = useCurrentUser();

  if (!currentUser) {
    return <Navigate to="/" replace />;
  }

  if (!allowedRoles.includes(currentUser.role)) {
    // Redirect to appropriate dashboard based on role
    return currentUser.role === "ADMIN" ? (
      <Navigate to="/admin" replace />
    ) : (
      <Navigate to="/staff" replace />
    );
  }

  return <Outlet />;
};

export default RoleBasedRoute;
